import React from 'react';
import { useDispatch } from 'react-redux';
import { IRootDispatch } from 'stores/rematch/root-store';
import { Row } from 'antd';
import { ICustomView } from 'interfaces/custom-views-interface';
import { CustomViewsModalType } from 'utilities/enum-utils';

export interface IBookingViewTabPopoverProps {
  currentTab: ICustomView;
  onHidePopOver: (isOpen: boolean) => void;
  onShowBookingViewModal: (viewModalType: CustomViewsModalType) => void;
}

export const BookingViewTabPopover = ({
  currentTab,
  onHidePopOver,
  onShowBookingViewModal,
}: IBookingViewTabPopoverProps) => {
  const { bookingsStore } = useDispatch<IRootDispatch>();
  const doUpdateBookingViewTab = bookingsStore.doUpdateBookingView;
  const hideBookingView = bookingsStore.hideBookingView;

  const onTogglePinView = async () => {
    onHidePopOver(false);
    await doUpdateBookingViewTab({ ...currentTab, isPinned: !currentTab.isPinned, isTogglePinned: true });
  };

  const onHideView = async () => {
    if (currentTab.customViewId) {
      onHidePopOver(false);
      hideBookingView({ customViewId: currentTab.customViewId });
    }
  };

  const onManageView = () => {
    onHidePopOver(false);
    onShowBookingViewModal(CustomViewsModalType.MANAGE);
  };

  const onDuplicateView = () => {
    onHidePopOver(false);
    onShowBookingViewModal(CustomViewsModalType.DUPLICATE);
  };

  return (
    <div style={{ margin: '-4px -16px' }}>
      <Row className='cursor-pointer ph-medium pv-small pr-large hover-bg-blue-lightest' onClick={onTogglePinView}>
        {currentTab.isPinned ? 'Unpin view' : 'Pin view'}
      </Row>
      {!currentTab.isPinned && (
        <Row className='cursor-pointer ph-medium pv-small pr-large hover-bg-blue-lightest' onClick={onHideView}>
          Hide view
        </Row>
      )}
      {currentTab.isOwner && (
        <Row className='cursor-pointer ph-medium pv-small pr-large hover-bg-blue-lightest' onClick={onManageView}>
          Manage view
        </Row>
      )}
      <Row className='cursor-pointer ph-medium pv-small pr-large hover-bg-blue-lightest' onClick={onDuplicateView}>
        Duplicate view
      </Row>
    </div>
  );
};
